'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fSegmentedButtonItem$002ejs from "@ui5/webcomponents/dist/SegmentedButtonItem.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  this.Ij = null;
  this.Ik = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-segmented-button-item");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$.prototype = $p;
$p.uB = (function() {
  if ((!this.Ik)) {
    this.Ij = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "selected", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.Ik = true;
  }
  return this.Ij;
});
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fSegmentedButtonItem$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$, "io.github.nguyenyou.ui5.webcomponents.laminar.SegmentedButtonItem$", ({
  jI: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_SegmentedButtonItem$ };
